import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";


export class ProgramaRepasseBndes extends BaseEntity {

  public descricaoPrograma: string;
  public esco: boolean;
  public indicadorEsco: boolean;
  public usuarioUltimaAtualizacao: string;
  public dataUltimaAtualizacao: Date;
	public aceitaBeneficiarioCpfRepasse: boolean;
	public desconsiderarPrazoTotalMaximoContratual: boolean;
  public abonoEcg: boolean;
  public idProgramaBndesTranche:number;

}

export class ProgramaBndesComIndicadorHabilitadoDTO extends ProgramaRepasseBndes {
  public habilitado: boolean;
}
